import { types } from "../../types/types";
import { ESTADOS_AUDITORIAFACTURACION_COMPRAS } from "../../utils/constants";


const initialState = {
    loading: false,
    comprobantes: [],
    estadosFacturacion: [],
    estadosFacturacionSelect: ESTADOS_AUDITORIAFACTURACION_COMPRAS.COMPROBANTE.toString(),
    contadorEstadosAuditoria: [],
    nuevoDetalleFacturacionSinCotizacion: [],
    comprobantesPorEstado: [],
    materialesTramite: [],
    materialesCotizacion: [],
    idSolicitudAuditoria: null,
    fechaInicioAuditoria: null,
    fechaFinAuditoria: null
}

export const AuditoriaFacturacionReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.seleccionarIdSolicitudAuditoria:
            return {
                ...state,
                idSolicitudAuditoria: action.payload,
                loading: false
            }
        case types.seleccionarFechaInicioAuditoria:
            return {
                ...state,
                fechaInicioAuditoria: action.payload,
                loading: false
            }
        case types.seleccionarFechaFinAuditoria:
            return {
                ...state,
                fechaFinAuditoria: action.payload,
                loading: false
            }
        case types.traerComprobantesAuditoriaFacturacionSuccess:
            return {
                ...state,
                comprobantes: action.payload,
                loading: false
            };
        case types.traerComprobantesAuditoriaFacturacionErrror:
            return {
                ...state,
                comprobantes: null,
                loading: false
            };
        case types.contadoresEstadosAuditoriaSuccess:
            return {
                ...state,
                contadorEstadosAuditoria: action.payload,
                loading: false
            }
        case types.contadoresEstadosAuditoriaError:
            return {
                ...state,
                contadorEstadosAuditoria: null,
                loading: false
            }
        case types.traerEstadosAuditoriaFacturacionSuccess:
            return {
                ...state,
                estadosFacturacion: action.payload,
                loading: false
            };
        case types.traerEstadosAuditoriaFacturacionError:
            return {
                ...state,
                estadosFacturacion: null,
                loading: false
            }
        case types.updateEstadosFacturacion:
            return {
                ...state,
                estadosFacturacionSelect: action.payload,
                loading: false
            }
        case types.seleccionarDetalleFacturacionSinCotizacion:
            return {
                ...state,
                nuevoDetalleFacturacionSinCotizacion: action.payload,
                loading: false
            }
        case types.desSeleccionarDetalleFacturacion:
            return {
                ...state,
                nuevoDetalleFacturacionSinCotizacion: [],
                loading: false
            }
        case types.traerComprobantesPorEstadoSuccess:
            return {
                ...state,
                comprobantesPorEstado: action.payload,
                loading: false
            }
        case types.traerComprobantesPorEstadoError:
            return {
                ...state,
                comprobantesPorEstado: [],
                loading: false
            }
        case types.traerMaterialesTramiteSuccess:
            return {
                ...state,
                materialesTramite: action.payload,
                loading: false
            }
        case types.traerMaterialesTramiteError:
            return {
                ...state,
                materialesTramite: [],
                loading: false
            }
        case types.traerMaterialesCotizacionSuccess:
            return {
                ...state,
                materialesCotizacion: action.payload,
                loading: false
            }
        case types.traerMaterialesCotizacionError:
            return {
                ...state,
                materialesCotizacion: [],
                loading: false
            }
        case types.traerMaterialesCotizacionLimpiar:
            return {
                ...state,
                materialesCotizacion: [],
                loading: false
            }
        default:
            return state;
    }
};